import type { ReactNode } from 'react';
import type { ValueElementIdReferenceAPI } from '../../../../../../../../types/value';
import FormGroup from '../../../../../../../generic/FormGroup';
import InputOrValuePicker from '../../../../../../../generic/InputOrValuePicker';

type ValuePickerWrapperProps = {
    id: string;
    label: string;
    isRequired?: boolean;
    testId: string;
    value: string | ValueElementIdReferenceAPI | undefined;
    container: HTMLElement | null;
    description?: string | undefined;
    children?: ReactNode;
    onChangeAsValueReference: (value: string | ValueElementIdReferenceAPI | null) => void;
};

const ValuePickerWrapper = ({
    id,
    label,
    isRequired = false,
    testId,
    value,
    container,
    description,
    children,
    onChangeAsValueReference,
}: ValuePickerWrapperProps) => {
    return (
        <FormGroup label={label} htmlFor={id} isRequired={isRequired} testId={testId}>
            <InputOrValuePicker
                value={value ?? null}
                onChangeAsValueReference={onChangeAsValueReference}
                contentType="ContentString"
                includeSystemValues={false}
                container={container}
            >
                {children}
            </InputOrValuePicker>
            {description && <p className="quiet ex-mt-2x-small">{description}</p>}
        </FormGroup>
    );
};

export default ValuePickerWrapper;
